module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_tick_rounded-2d29781285fd88adb000404f0504d50c.svg";